import { ButtonLink } from '@app/components/base/ButtonLink';
import { DailymotionPlatform } from '@app/modules/social-export/domain/platforms';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { DefaultPlatformConnect } from '../../../screens/manage/DefaultPlatformConnect';

type Props = {
  stationId: string;
};

export function DailymotionConnect({ stationId }: Props) {
  return (
    <Box display="flex" gap={2}>
      <DefaultPlatformConnect platform={DailymotionPlatform} stationId={stationId}>
        <FormattedMessage
          id="socialExport.dailymotion.connectViaLogin"
          defaultMessage="Conectar via login"
        />
      </DefaultPlatformConnect>{' '}
      <ButtonLink
        variant="outlined"
        color="primary"
        size="small"
        to={`/admin/social-export/dailymotion/connect/${stationId}`}
        startIcon={DailymotionPlatform.Icon()}
      >
        <FormattedMessage
          id="socialExport.dailymotion.connectViaApiKey"
          defaultMessage="Conectar via API key"
        />
      </ButtonLink>
    </Box>
  );
}
